var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 13.5c.22 0 .43.094.576.26l3.27 3.71a.614.614 0 01-.065.855.617.617 0 01-.86-.044l-2.859-3.244a.083.083 0 00-.125 0l-2.86 3.244a.616.616 0 01-1.056-.203.613.613 0 01.132-.609l3.27-3.708a.77.77 0 01.576-.261z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
}
export default SvgChevronUp;